import axios from 'axios'

export const appisAmulenCore = axios.create({
  baseURL: process.env.VUE_APP_API
})

export const setAuthHeaderAmulenCore = (token) => {
  appisAmulenCore.defaults.headers.common.Authorization = `Bearer ${token}`
}

export const appisAmulenApi = axios.create({
  baseURL: process.env.VUE_APP_API2
})

export const setAuthHeaderAmulenApi = (token) => {
  appisAmulenApi.defaults.headers.common.Authorization = `Bearer ${token}`
}

export const appisElearning = axios.create({
  baseURL: process.env.VUE_APP_API3
})

export const setAuthHeaderElearning = (token) => {
  appisElearning.defaults.headers.common.Authorization = `Bearer ${token}`
}

export const appisElearning2 = axios.create({
  baseURL: process.env.VUE_APP_API4,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
})
